import { defaultTrashFilterDocument } from '@griply/utils';
import React, { useRef } from 'react';
import { VirtualizedTreeListProvider } from 'shared/components/ui/virtualized-tree-list';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { PageTopBar } from './components/page-top-bar';
import { TrashEmptyState } from './components/trash-empty-state';
import * as Styled from './trash.style';

const noOrder = {};
const hideNewTaskRowOverride = { hideNewTaskRow: true };

export const Trash: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Main>
        <VirtualizedTreeListProvider>
          <Styled.MainContent>
            <PageTopBar />
            <Styled.Content ref={scrollRef}>
              <ProvidedTaskFilterList
                scrollElement={scrollRef}
                filterDocument={defaultTrashFilterDocument}
                defaultFilterDocument={defaultTrashFilterDocument}
                customOrder={noOrder}
                groupSettingOverrides={hideNewTaskRowOverride}
                EmptyState={TrashEmptyState}
                includeArchived
                includeTaskWithAction
              />
            </Styled.Content>
          </Styled.MainContent>
        </VirtualizedTreeListProvider>
      </Styled.Main>
    </Styled.Container>
  );
};
